<template>
  <TopPanel>
    <BreadCrumbs :items="items" class="s-bread" />
    <div class="button-container">
      <Button
        label="Сохранить"
        class="save-button m-l-16 m-r-16"
        :disabled="isDenied || !hasChanges"
        @click="saveCoefficients"
        :loading="isLoading"
      />
    </div>
  </TopPanel>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import Button from "primevue/button";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";

const props = defineProps<{
  isLoading: boolean;
  hasChanges: boolean;
}>();

const emit = defineEmits(["save"]);

const authStore = useAuthStore();

const items = [{ label: "Расходы" }, { label: "Коэффициенты" }];

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["expenses:edit"]);
});

const saveCoefficients = () => {
  emit("save");
};
</script>

<style lang="scss" scoped>
.s-bread {
  margin-left: 18px;
}

.button-container {
  flex: 1;
  display: flex;
  justify-content: end;
  margin: 0 20px;
}

.save-button {
  width: 200px;
}
</style>
